<div class="feedback detail">
    <div class="feedback-question-container">
      <b class="feedback-question">Why did you choose this rating ? (optional) </b>
      <mat-icon fontIcon="close" style="cursor: pointer;" (click)="closeFeedbackDetail()">
      </mat-icon>
    </div>
    <div class="feedback-reason-container">
      @for (option of feedbackReasonOptions; track option) {
        <button type="submit" class="feedback-reason" (click)="selectOption(option)" [ngClass]="option === feedbackReason ? 'feedback-selected-reason': ''">{{option}}</button>
      }
    </div>
    <div>
      <input type="text" placeholder="Additional Feedback" class="feedback-input-box" [(ngModel)]="feedbackReasonText" maxlength="250"/>
    </div>
    <div class="feedback-caution">
      *Please do not provide any personal or sensitive data*
    </div>
    <div class="feedback-button-container">
      <button type="submit" class="feedback-button" (click)="submitFeedback()" [disabled]="feedbackReasonText.length===0 || feedbackReason.length===0">Submit</button>
    </div>
</div>